import PropTypes from 'prop-types'
import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import ArrowBackIcon from 'react-icons/lib/md/arrow-back'

import { rhythm, scale } from '../utils/typography'
import presets from '../utils/presets'
import Bio from '../components/Bio'
import ReadingTime from '../components/ReadingTime'

const Template = ({ data, pathContext }) => {
  return (
    <div>
      <Helmet
        title={`${data.markdownRemark.frontmatter.title} | ${
          data.site.siteMetadata.title
        } `}
        meta={[
          {
            name: 'description',
            content: data.markdownRemark.frontmatter.excerpt
          }
        ]}
      />
      <h2
        css={{ marginTop: rhythm(1), [presets.Phablet]: { display: 'none' } }}>
        <Link css={{ backgroundImage: 'none' }} to="/">
          <ArrowBackIcon />
        </Link>
      </h2>
      <h2 css={{ marginTop: 0, [presets.Phablet]: { marginTop: rhythm(1) } }}>
        <Link
          css={{
            visibility: 'hidden',
            backgroundImage: 'none',
            marginLeft: rhythm(-1.5),
            marginRight: rhythm(0.5),
            [presets.Phablet]: {
              visibility: 'visible'
            }
          }}
          to="/">
          <ArrowBackIcon style={{ verticalAlign: 'bottom' }} />
        </Link>
        {data.markdownRemark.frontmatter.title}
      </h2>
      <p
        css={{
          ...scale(-1 / 5),
          display: 'block',
          marginBottom: rhythm(1),
          marginTop: rhythm(-0.8),
          color: 'hsla(0,0%,0%,0.34)'
        }}>
        {data.markdownRemark.frontmatter.date}
        <ReadingTime words={data.markdownRemark.frontmatter.words} />
      </p>

      <div dangerouslySetInnerHTML={{ __html: data.markdownRemark.html }} />
      <div
        css={{
          display: `flex`,
          justifyContent: 'space-between',
          flexDirection: 'row',
          alignItems: 'stretch',
          marginBottom: rhythm(1)
        }}>
        <div>
          {pathContext.prev && (
            <Link to={pathContext.prev.frontmatter.path}>
              <h4 css={{ margin: 0 }}>Previous</h4>
              <span>{pathContext.prev.frontmatter.title}</span>
            </Link>
          )}
        </div>
        <div css={{ textAlign: 'right' }}>
          {pathContext.next && (
            <Link to={pathContext.next.frontmatter.path}>
              <h4 css={{ margin: 0 }}>Next</h4>
              <span>{pathContext.next.frontmatter.title}</span>
            </Link>
          )}
        </div>
      </div>
    </div>
  )
}

Template.propTypes = {
  data: PropTypes.object.isRequired,
  pathContext: PropTypes.object.isRequired
}

export const pageQuery = graphql`
  query Template($path: String!) {
    site {
      siteMetadata {
        title
      }
    }
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        path
        words
        excerpt
      }
    }
  }
`

export default Template



// WEBPACK FOOTER //
// ./src/templates/blog-post.js